import React, { ReactElement } from 'react';

import { Profile } from '../../../../shared/profile';
import { MEMBERS } from '../../constants';
import * as S from './Team.styles';

export const Team = (): ReactElement => {
  return (
    <>
      <S.Wrapper>
        <S.SubCaption>our team</S.SubCaption>
        <S.Caption>Meet our team of experts</S.Caption>
        <S.ContentBlock>
          {MEMBERS.map(({ img, name, position, link }) => (
            <Profile key={name} img={img} link={link} name={name} position={position} />
          ))}
        </S.ContentBlock>
      </S.Wrapper>
    </>
  );
};
